export default "__VITE_ASSET__Ckh1afxx__"